import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}`;

export const ROUTE: RouteDefinition = `${baseRoute}`;

export const URL = (): RouteDefinition => `${baseRoute}`;
